
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artigos",
      function () {
        return require("private-next-pages/artigos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artigos"])
      });
    }
  